    import React, { useState, useEffect, useRef } from 'react';
    import { useNavigate, useLocation } from 'react-router-dom';
    import { auth, googleProvider } from '../firebase';
    import {
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
  } from "firebase/auth";
    import { signInWithRedirect, getRedirectResult, OAuthProvider, signInWithPopup } from 'firebase/auth';
    import usersLogo from '../assets/users.png';
    import googleLogo from '../assets/google.png';
    import classicLogo from '../assets/classic.png';
    import logo from '../assets/heydiari.png';
    import { doc, setDoc, getDoc } from "firebase/firestore";
    import { db } from "../firebase";
    import { makeFakeEmail } from "../utils/authHelpers";

    function Landing() {
      const [isTallScreen, setIsTallScreen] = useState(
        window.innerHeight > window.innerWidth
      );

      useEffect(() => { 
        const handleResize = () => {
          setIsTallScreen(window.innerHeight > window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);

      const navigate = useNavigate();
      const location = useLocation();
      const [dateTime, setDateTime] = useState('');
      const [videoInfo, setVideoInfo] = useState({ title: '', channel: '' });
      const playerRef = useRef(null);
      const [playerReady, setPlayerReady] = useState(false);
      const [isPlaying, setIsPlaying] = useState(false);
      const [showLightbox, setShowLightbox] = useState(false);
      const [activeTab, setActiveTab] = useState("login");
      const [email, setEmail] = useState("");
      const [username, setUsername] = useState("");
      const [password, setPassword] = useState("");
      const [confirmPassword, setConfirmPassword] = useState("");
      const [shake, setShake] = useState(false);
      const [showUserLightbox, setShowUserLightbox] = useState(false);
      const [usersTab, setUsersTab] = useState("login");
    

      const apiKey = 'AIzaSyBhPk034uz-x_E5vewJDGAD35cYN-kE4FI';
      const videoId = 'eKO9BGdQ7Wk';

      const images = [
        "/images/magnetrc1.jpg",
        "/images/magnetrc2.jpg",
        "/images/magnetrc3.jpg",
        "/images/magnetrc4.jpg",
        "/images/magnetrc5.jpg",
        "/images/magnetrc1.jpg",
        "/images/magnetrc4.jpg",
        "/images/magnetrc5.jpg",
      ];

      const [current, setCurrent] = useState(0);
      const checkUserProfile = async (user) => {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);

    return docSnap.exists();
  };

    // Auto slideshow
    useEffect(() => {
      const timer = setInterval(() => {
        setCurrent((prev) => (prev + 1) % images.length);
      }, 3000);
      return () => clearInterval(timer);
    }, []);

    const carouselStyle = {
      width: "600px",
      height: "367px",
      objectFit: "cover",
      maxWidth: "100%",
      maxHeight: "100%",
      display: "block",
    };

    const previewContainerStyle = {
      display: "flex",
      width: "100%",
      maxWidth: "600px",
      gap: "8px",
      marginTop: "15px",
    };

    const previewStyle = {
      flex: 1,
      height: "60px",
      objectFit: "cover",
      aspectRatio: "1 / 1",
      cursor: "pointer",
      opacity: 0.7,
    };

    const activePreviewStyle = {
      ...previewStyle,
      opacity: 1,
      border: "2px solid #696969",
    };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.6)", // dark background
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999
  };

  const modalStyle = {
    background: "rgba(255, 255, 255, 0.85)",
    border: "1px solid rgba(255,255,255,0.6)",
    padding: "30px",
    width: "400px",
    height: "280px",
    position: "relative",
    boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
    color: "#000",
    display: "flex",
    flexDirection: "column"
  };

  const inputStyle = {
    width: "100%",
    padding: "12px",
    marginBottom: "12px",
    borderRadius: "10px",
    border: "1px solid rgba(0,0,0,0.1)", // ✅ FIX
    background: "rgba(255,255,255,0.9)", // ✅ FIX
    color: "#000", // ✅ FIX (was white ❌)
    outline: "none"
  };

  const loginBtnStyle = {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "none",
    background: "#fff",
    color: "#000",
    cursor: "pointer",
    marginTop: "10px",
    fontWeight: "600"
  };

  const closeBtnStyle = {
    position: "absolute",
    top: "10px",
    right: "15px",
    border: "none",
    background: "transparent",
    fontSize: "20px",
    cursor: "pointer"
  };

  const tabContainer = {
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    marginBottom: "20px",
    borderBottom: "1px solid rgba(0,0,0,0.1)",
    paddingBottom: "10px"
  };

  const tabStyle = {
    cursor: "pointer",
    color: "rgba(0,0,0,0.5)"
  };

  const activeTabStyle = {
    cursor: "pointer",
    color: "#000",
    fontWeight: "600",
    borderBottom: "2px solid #000",
    paddingBottom: "5px"
  };

   const usersTabStyle = {
    cursor: "pointer",
    color: "#000",
    fontWeight: "600",
    borderBottom: "2px solid #000",
    paddingBottom: "5px"
  };

  const actionBtnStyle = {
    width: "200px",              // ✅ fixed width (NOT 100%)
    padding: "12px",
    borderRadius: "25px",
    border: "none",
    background: "#696969",
    color: "#fff",
    cursor: "pointer",
    marginTop: "20px",
    fontWeight: "600",
    textAlign: "center",
    alignSelf: "center",         // ✅ THIS centers it inside flex
    transition: "0.25s ease"
  };

      // Clock
      useEffect(() => {
        const updateClock = () => {
          const now = new Date();
          const datePart = now.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          });
          const dayPart = now.toLocaleDateString('en-US', { weekday: 'long' });
          const timePart = now.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
          });
          setDateTime(`${dayPart} ✦ ${datePart} ✦ ${timePart}`);
        };
        updateClock();
        const interval = setInterval(updateClock, 1000);
        return () => clearInterval(interval);
      }, []);

      const headerLineText = "✦ Be a member and create your story with us! ✦";

      // Fetch video info from YouTube API
      useEffect(() => {
        if (!apiKey || !videoId) return;

        fetch(
          `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${apiKey}`
        )
          .then(res => res.json())
          .then(data => {
            if (data.items && data.items.length > 0) {
              const snippet = data.items[0].snippet;
              setVideoInfo({
                title: snippet.title,
                channel: snippet.channelTitle,
              });
            }
          })
          .catch(err => console.error('YouTube API error:', err));
      }, [apiKey, videoId]);

      // Load YouTube IFrame API
      useEffect(() => {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(tag);

        window.onYouTubeIframeAPIReady = () => {
          if (!playerRef.current) {
            playerRef.current = new window.YT.Player('hidden-youtube', {
              height: '0',
              width: '0',
              videoId: videoId,
              playerVars: {
                autoplay: 0,
                controls: 0,
                modestbranding: 1,
                rel: 0,
                loop: 1,
                playlist: videoId,
              },
              events: {
                onReady: () => setPlayerReady(true),
              },
            });
          }
        };
      }, [videoId]);

      useEffect(() => {
        const handleSingleClick = () => {
          if (playerRef.current && playerReady && !isPlaying) {
            playerRef.current.playVideo();
            setIsPlaying(true);
          }
        };
        const handleDoubleClick = () => {
          if (playerRef.current && playerReady && isPlaying) {
            playerRef.current.pauseVideo();
            setIsPlaying(false);
          }
        };

        window.addEventListener('click', handleSingleClick);
        window.addEventListener('dblclick', handleDoubleClick);

        return () => {
          window.removeEventListener('click', handleSingleClick);
          window.removeEventListener('dblclick', handleDoubleClick);
        };
      }, [playerReady, isPlaying]);

      // Firebase login
      useEffect(() => {
        getRedirectResult(auth)
          .then((result) => {
            if (result) {
              navigate('/home');
            }
          })
          .catch(console.error);
      }, [navigate]);

  const handleGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const hasProfile = await checkUserProfile(user);

      if (hasProfile) {
        navigate("/home");
      } else {
        navigate("/create");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setShowLightbox(false);
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      navigate("/home");
    } catch (error) {
      alert(error.message);
    }
  };

  const handleSignUp = async () => {
    if (password !== confirmPassword) return; // ❌ no shake, just stop

    try {
      await createUserWithEmailAndPassword(auth, email, password);

      setShowLightbox(false);
      setEmail("");
      setPassword("");
      setConfirmPassword("");

      navigate("/create"); // ✅ updated route
    } catch (error) {
      console.error(error);
    }
  };

const handleUserSignup = async () => {
  try {
    const email = makeFakeEmail(username);

    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    console.log("User created:", userCredential.user);

    navigate("/create");
  } catch (error) {
  console.log("Signup error:", error.code);

  if (error.code === "auth/email-already-in-use") {
    alert("Username already taken. Try another one.");
  } else if (error.code === "auth/weak-password") {
    alert("Password is too weak.");
  } else {
    alert("Something went wrong. Try again.");
  }
}
};

const handleUserLogin = async () => {
  try {
    const email = makeFakeEmail(username);

    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );

    console.log("Logged in:", userCredential.user);

    navigate("/home");
  } catch (error) {
    console.log("Login error:", error.code, error.message);
  }
};

      return (
        <div
          style={{
            minHeight: '100vh',
            width: '100%',
            backgroundColor: 'linear-gradient(135deg, #e7e7e7, #dcdcdc), radial-gradient(circle at 30% 20%, rgba(255,255,255,0.4), transparent 40%), radial-gradient(circle at 70% 80%, rgba(0,0,0,0.08), transparent 45%)',
            fontFamily: '"Inter", sans-serif',
            color: '#000',
            overflowX: 'auto',
            overflowY: 'auto',
            paddingTop: '92px',
            boxSizing: 'border-box',
          }}
        >
          {/* HEADER */}
          <div
            style={{
              width: '100%',
              minHeight: '60px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingRight: '20px',
              paddingLeft: '20px',
              position: 'fixed',
              top: 0,
              backgroundColor: '#F2E7E0',
              color: '#000',
              zIndex: 100,
              boxSizing: 'border-box',
            }}
          >
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
              <span onClick={() => navigate('/')} className={`nav-item ${location.pathname === '/' ? 'active' : ''}`} > Home </span>
              <span onClick={() => navigate('/engage')} className={`nav-item ${location.pathname === '/engage' ? 'active' : ''}`} > Engage </span>
              <span onClick={() => navigate('/yard')} className={`nav-item ${location.pathname === '/yard' ? 'active' : ''}`} > Yard </span>
            </div>
            <div className="datetime" style={{ fontWeight: 'normal', fontSize: '0.9rem', whiteSpace: 'nowrap', flexShrink: 0 }}>
              {dateTime}
            </div>
          </div>

          {/* GRAY LINE */}
          <div style={{
            width: '100%',
            backgroundColor: '#696969',
            height: '23px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'fixed',
            top: '58px',
            zIndex: 90,
          }}>
            <span className="slide-right-text">{headerLineText}</span>
          </div>

          {/* MAIN CONTENT */}
          <div className="landing-main" style={{
            width: '100%',
            maxWidth: '1440px',
            margin: '0 auto',
            minHeight: 'calc(100vh - 147px)',
            flexWrap: 'wrap',
            padding: '0 10px',
            gap: '10px',
            boxSizing: 'border-box',
            scrollbarWidth: 'none',
            justifyContent: 'space-evenly',   // center both panels as a group
            alignItems: 'center',       // vertical centering
          }}>
            {/* LEFT TEXT PANEL */}
            <div style={{ flex: '0 0 auto', minWidth: '300px', maxWidth: '300px', textAlign: 'center', justifyContent: 'center' }}>
              <img
                src={logo}
                alt="Hey Diari"
                style={{
                height: 'auto',        // controls logo size
                width: '310px',
                margin: 'auto auto 50px -4px',
                display: 'block',
                }}
              />
              <p style={{ fontSize: '.8rem', maxWidth: '320px', margin: '0 auto 15px auto', textAlign: 'center', letterSpacing: '1.2px', transform: 'scaleY(.95)', lineHeight: '1.5' }}>
                Choose how you’d like to <br /> access your space. Unlock it via:
              </p>
              <button className="users-button" onClick={() => setShowUserLightbox(true)} style={usersButtonStyle}>
                <img src={usersLogo} alt="Users" style={usersIconStyle} /> <span style={{ letterSpacing: ".6px", wordSpacing: "4px" }}>
                Users Portal</span>
              </button>
              <button className="google-button" onClick={handleGoogle} style={googleButtonStyle}>
                <img src={googleLogo} alt="Google" style={googleIconStyle} />
                Google Portal
              </button>
              <button className="classic-button" onClick={() => setShowLightbox(true)} style={classicButtonStyle}>
                <img src={classicLogo} alt="Classic" style={classicIconStyle} />
                Classic Portal
              </button>
            </div>
          
  {showUserLightbox && (
    <div style={overlayStyle} onClick={() => setShowUserLightbox(false)}>
      
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        
        <button style={closeBtnStyle} onClick={() => setShowUserLightbox(false)}>
          ✕
        </button>

        {/* Tabs */}
        <div style={tabContainer}>
          <span
            style={usersTab === "login" ? usersTabStyle : tabStyle}
            onClick={() => setUsersTab("login")}
          >
            Access your space
          </span>
          <span
            style={usersTab === "signup" ? usersTabStyle : tabStyle}
            onClick={() => setUsersTab("signup")}
          >
            Become a member
          </span>
        </div>

        {/* LOGIN */}
        {usersTab === "login" ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
            
            <input
              type="text"
              placeholder="Username"
              style={inputStyle}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <input
              type="password"
              placeholder="Secret code"
              style={inputStyle}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button style={actionBtnStyle} onClick={handleUserLogin}>
              Unlock
            </button>
          </div>
        ) : (
          
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
            
            <input
              type="text"
              placeholder="Choose a username"
              style={inputStyle}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <input
              type="password"
              placeholder="Secret code"
              style={inputStyle}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <input
              type="password"
              placeholder="Repeat secret code"
              style={inputStyle}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <button style={actionBtnStyle} onClick={handleUserSignup}>
              Join
            </button>
          </div>
        )}

      </div>
    </div>
  )}

  {showLightbox && (
    <div style={overlayStyle} onClick={() => setShowLightbox(false)}>
      
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        
        <button style={closeBtnStyle} onClick={() => setShowLightbox(false)}>
          ✕
        </button>

        {/* Tabs */}
        <div style={tabContainer}>
          <span
            style={activeTab === "login" ? activeTabStyle : tabStyle}
            onClick={() => setActiveTab("login")}
          >
            Access your space
          </span>
          <span
            style={activeTab === "signup" ? activeTabStyle : tabStyle}
            onClick={() => setActiveTab("signup")}
          >
            Become a member
          </span>
        </div>

        {/* Content */}
        {activeTab === "login" ? (
          <div style={{  marginTop: "px", display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
            <input type="email" placeholder="Email" style={inputStyle} value={email} onChange={(e) => setEmail(e.target.value)} />
            <input type="password" placeholder="Secret code" style={inputStyle} value={password} onChange={(e) => setPassword(e.target.value)}/>
            <button style={actionBtnStyle} className="action-btn" onClick={handleLogin}> Unlock</button>
          </div>
        ) : (
          <div style={{  marginTop: "5px", display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
    <input
      type="email"
      placeholder="Email"
      style={inputStyle}
      value={email}
      onChange={(e) => setEmail(e.target.value)}
    />

    <input
      type="password"
      placeholder="Secret code"
      style={inputStyle}
      value={password}
      onChange={(e) => setPassword(e.target.value)}
    />

    <input
      type="password"
      placeholder="Repeat secret code"
        style={{
      ...inputStyle,
      border: shake ? "1px solid red" : inputStyle.border,
      }}
      className={shake ? "shake" : ""}
      value={confirmPassword}
      onChange={(e) => setConfirmPassword(e.target.value)}
    />

    <button style={actionBtnStyle} className="action-btn" onClick={handleSignUp}>
      Join
    </button>
  </div>
        )}

      </div>
    </div>
  )}

          {/* RIGHT CAROUSEL */}
          {!isTallScreen && (
            <div className="carousel-wrapper" style={{ textAlign: 'center' }}>
              <img src={images[current]} style={carouselStyle} />
              <div style={previewContainerStyle}>
                {images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    onClick={() => setCurrent(i)}
                    style={i === current ? activePreviewStyle : previewStyle}
                  />
                ))}
              </div>
            </div>
          )}
        </div>

          {/* HIDDEN YOUTUBE PLAYER */}
          <div style={{ width: 0, height: 0, overflow: 'hidden' }}>
            <div id="hidden-youtube"></div>
          </div>

          {/* STYLES */}
          <style>{`
            .slide-right-text {
              color: #ffff;
              display: inline-block;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-weight: 100;
              letter-spacing: 1.1px;
              white-space: nowrap;
              position: relative;
              animation: slideRight 8s ease-in-out infinite;
            }
            @keyframes slideRight {
              0% { transform: translateX(120%) scaleY(.9); opacity: 0; }
              18.75% { transform: translateX(0%) scaleY(0.9); opacity: 1; }
              81.25% { transform: translateX(0%) scaleY(0.9); opacity: 1; }
              100% { transform: translateX(-120%) scaleY(0.9); opacity: 0; }
            }
            /* hide scrollbar for WebKit */
            div::-webkit-scrollbar { display: none; }
            @media (max-width: 768px) {
              .slide-right-text { font-size: 0.85rem; }
            }

            .landing-main {
              display: flex;
              flex-direction: row;
            }

            @media (max-aspect-ratio: 1/1) {
              .landing-main {
              flex-direction: column;
            }

            @media (max-width: 600px) {
              .datetime {
              display: none !important;
              }
            }

            .panel {
              max-width: 100%;
            }

            .carousel-wrapper {
              display: none !important;
            }
            }

            .users-button,
            .google-button,
            .classic-button {
                transition: transform 0.25s cubic-bezier(.34,1.56,.64,1);
                box-shadow 0.25s ease;
              will-change: transform;
            }

            .users-button:hover,
            .google-button:hover,
            .classic-button:hover {
              transform: scale(1.08);
              box-shadow: 0 10px 22px rgba(0,0,0,0.18);
            }

            .users-button:active,
            .google-button:active,
            .classic-button:active {
              transform: scale(0.96);
            }

            .nav-item {
              cursor: pointer;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-weight: 200;
              letter-spacing: .3px;
              transform: scaleY(.85) translateY(1px);
              text-transform: uppercase;
              display: inline-block;
              color: #464646;
            }

            /* Hover bounce */
            .nav-item:hover {
              color: #000;
            }

            /* Active tab */
            .nav-item.active {
              font-weight: 700;
              color: #000;
            }

            /* Keep hover working on active */
            .nav-item.active:hover {
            }

            .datetime {
              display: inline-block;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              letter-spacing: 1px;
              transform: scaleY(.9);
            }
          `}</style>
        </div>
      );
    }

    // NAV AND BUTTON STYLES
    const navItemStyle = { opacity: 0.8, fontWeight: 'normal', cursor: 'pointer' };
const usersButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center', // 👈 IMPORTANT (center everything)
  gap: '9px',              // 👈 controls spacing between icon & text
  height: '45px',
  padding: '0 15px',
  margin: '0 auto 15px auto',
  width: '100%',
  maxWidth: '310px',
  border: 'none',
  borderRadius: '35px',
  fontSize: '1.1rem',
  fontFamily: 'Inter, sans-serif',
  backgroundColor: '#F2E7E0',
  color: '#000',
  cursor: 'pointer'
};
const googleButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center', // 👈 IMPORTANT (center everything)
  gap: '9px',              // 👈 controls spacing between icon & text
  height: '45px',
  padding: '0 15px',
  margin: '0 auto 15px auto',
  width: '100%',
  maxWidth: '310px',
  border: 'none',
  borderRadius: '35px',
  fontSize: '1.1rem',
  fontFamily: 'Inter, sans-serif',
  backgroundColor: '#cad6c2',
  color: '#000',
  cursor: 'pointer'
};
const classicButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center', // 👈 IMPORTANT (center everything)
  gap: '9px',              // 👈 controls spacing between icon & text
  height: '45px',
  padding: '0 15px',
  margin: '0 auto 15px auto',
  width: '100%',
  maxWidth: '310px',
  border: 'none',
  borderRadius: '35px',
  fontSize: '1.1rem',
  fontFamily: 'Inter, sans-serif',
  backgroundColor: '#696969',
  color: '#ffff',
  cursor: 'pointer'
};
const usersIconStyle = {
  marginLeft: '-11px',
  width: '2.3em',
  height: '2.3em',
  objectFit: 'contain',
  display: 'block'
};
const googleIconStyle = {
  marginLeft: '-11px',
  width: '2.3em',
  height: '2.3em',
  objectFit: 'contain',
  display: 'block'
};
const classicIconStyle = {
  marginLeft: '-11px',
  width: '2.3em',
  height: '2.3em',
  objectFit: 'contain',
  display: 'block'
};
    export default Landing;
